/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmergency = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9.078 2h6v4.825L19.205 4.4l3.039 5.174-4.32 2.537 3.94 2.315-3.038 5.174-3.748-2.202V22h-6v-4.693L5.174 19.6l-3.039-5.174 3.941-2.315-4.32-2.537L4.795 4.4l4.283 2.516zm2 8.41L5.506 7.138 4.494 8.862l5.531 3.25-5.152 3.026 1.013 1.724 5.192-3.05V20h2v-6.096l5.036 2.958 1.013-1.724-5.153-3.027 5.532-3.249-1.013-1.724-5.415 3.18V4h-2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEmergency as Emergency };
